<div class="content">
  <div class="card">
    <div class="card-content">
      <div class="card-body">

        <button routerLink="/schools" title="{{ 'inputs.back' | translate }}" mat-icon-button>
          <mat-icon>keyboard_backspace</mat-icon>
          {{ 'inputs.back' | translate }}
        </button>

        <h1>{{ 'titles.edit.upload_students_excel' | translate }}</h1>

        <div style="clear: left;"></div>

        <div class="media-body">

          <div class="contenedor" [formGroup]="studentForm">
            <input matInput [hidden]="true" [formControlName]="'id'" type="text" placeholder="id">

            <mat-form-field appearance="legacy">
              <mat-label>{{ 'inputs.stages' | translate }}</mat-label>
              <mat-select matNativeControl [formControlName]="'stages'" (selectionChange)="getGrades($event.value)">
                <mat-option *ngFor="let stage of stages" [value]="stage.id">
                  {{stage.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="legacy">
              <mat-label>{{ 'inputs.grades' | translate }}</mat-label>
              <mat-select matNativeControl [formControlName]="'grades'">
                <mat-option *ngFor="let grade of grades" [value]="grade.id">
                  {{grade.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="columns" *ngIf="studentForm.value.grades!='' && studentForm.value.grades!=null">
              <mat-label *ngIf="selectedFiles; else newFile">{{selectedFiles.item(0).name}}</mat-label>
              <ng-template #newFile>
                <mat-label>{{ 'inputs.choose_xls_file' | translate }}</mat-label>
              </ng-template>
              <input matInput disabled>
              <button mat-icon-button matSuffix (click)="fileInput_primary.click()">
                <mat-icon>attach_file</mat-icon>
              </button>
              <input hidden (change)="selectFile($event, 'primary')" #fileInput_primary type="file" id="file"
                accept={{type_accept}}>
            </mat-form-field>

            <!-- <mat-form-field class="columns">
                <mat-label *ngIf="selectedSecondaryFiles; else newSecondaryFile">{{selectedSecondaryFiles.item(0).name}}
                </mat-label>
                <ng-template #newSecondaryFile>
                  <mat-label>{{ 'inputs.choose_secondary_image' | translate }}</mat-label>
                </ng-template>
                <input matInput disabled>
                <button mat-icon-button matSuffix (click)="fileInput_secondary.click()">
                  <mat-icon>attach_file</mat-icon>
                </button>
                <input hidden (change)="selectFile($event, 'secondary')" #fileInput_secondary type="file"
                  id="secondaryfile" accept={{type_accept}}>
              </mat-form-field> -->



            <!-- <mat-progress-bar *ngIf="showStudentPhotosProgressBar2" mode="indeterminate"></mat-progress-bar> -->


            <div class="float-button-container">
              <button mat-fab color="primary" aria-label="save" (click)="uploadStudents()">
                <mat-icon>save</mat-icon>
              </button>
            </div>
          </div>
          <div *ngIf="showPrimarySpinner" class="spinner-wrapper">
            <mat-spinner class="spinner-inner"></mat-spinner>
          </div>




          <div class="wpb_wrapper">
            <div class="vc_message_box vc_message_box-standard vc_message_box-rounded vc_color-info">
              <div class="vc_message_box-icon">
                <mat-icon class="icon">info</mat-icon>
              </div>
              <p><b>{{'upload_students.title' | translate}}</b><br>
                {{'upload_students.subtitle' | translate}}</p>
              <ul>
                <li>{{'upload_students.txt1' | translate}}</li>
                <li>{{'upload_students.txt2' | translate}}</li>
                <li>{{'upload_students.txt3' | translate}}</li>
                <li>{{'upload_students.txt4' | translate}}</li>
              </ul>
            </div>
          </div>
          <!-- Para descargar la plantilla pulse <a href="https://drive.google.com/file/d/1CU-p0Y74hN-rIuHuyqVCq_NuUW3bT9cP/view?usp=sharing" target="_blank" rel="noopener noreferrer">aquí</a> -->
          {{'upload_students.download_txt' | translate}} <a
            href="https://storage.googleapis.com/maknetic.appspot.com/Plantilla%20subida%20escuela.xlsx" target="_blank"
            rel="noopener noreferrer">{{'upload_students.here' | translate}}</a>


        </div>
      </div>
    </div>



  </div>